import { z } from "zod"
import { createDeviceStorageItem } from "@/shared/lib/storage"

// Инлайн-скрипт в index.html проверяет `luni:device:splash-seen` === "true"
// до загрузки бандла — ключ, скоуп и формат значения менять синхронно с ним.
const splashSeen = createDeviceStorageItem({
	key: "splash-seen",
	schema: z.boolean(),
	fallback: false,
})

// Builds before 2.21.0 kept the flag in this plain key. Without it, every
// returning device plays the full first-launch splash once more.
const LEGACY_SPLASH_SEEN_KEY = "splash-seen"

function hasLegacySplashSeen(): boolean {
	try {
		return localStorage.getItem(LEGACY_SPLASH_SEEN_KEY) !== null
	} catch {
		return false
	}
}

/** The splash markup lives in index.html and covers #root until dropped. */
export function removeSplash(): void {
	document.getElementById("splash")?.remove()
}

export function hasSeenSplash(): boolean {
	return splashSeen.get() || hasLegacySplashSeen()
}

export function markSplashSeen(): void {
	if (!splashSeen.set(true)) return
	try {
		localStorage.removeItem(LEGACY_SPLASH_SEEN_KEY)
	} catch {}
}
